import { useState } from "react";

const TESTIMONIALS = [
  {
    name: "Sarah Mitchell",
    role: "Homeowner · Coral Gables, FL",
    avatar: "https://public.readdy.ai/ai/img_res/cacb18921e76daf36cbddc980557332e.jpg",
    rating: 5,
    text: "ZoroBabel Cleaning Services transformed my home in Coral Gables! I was skeptical at first, but after the first session I was completely blown away. Every surface was spotless — they even cleaned behind the fridge. I&apos;ve been a weekly subscriber for 8 months now.",
    service: "Residential Cleaning",
  },
  {
    name: "David Chen",
    role: "Office Manager · Brickell, FL",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20smiling%20confident%20asian%20man%20early%2040s%20business%20casual%20bright%20background%20clean%20minimal%20portrait%20style&width=200&height=200&seq=avatar2&orientation=squarish",
    rating: 5,
    text: "We use ZoroBabel Cleaning Services for our entire office in Brickell — 120 desks. Their team is incredibly professional, always on time, and the results speak for themselves. Our employees rave about how clean the workspace is every Monday morning.",
    service: "Commercial Cleaning",
  },
  {
    name: "Emma Rodriguez",
    role: "Property Manager · Miami Beach, FL",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20smiling%20latina%20woman%20late%2020s%20warm%20smile%20bright%20background%20clean%20minimal%20portrait%20photography%20style&width=200&height=200&seq=avatar3&orientation=squarish",
    rating: 5,
    text: "I manage rental properties across Miami Beach and ZoroBabel handles all my move-in/move-out cleanings. Their thoroughness is unmatched. New tenants always comment on how fresh and clean the units feel. Highly recommend for any property manager in South Florida.",
    service: "Move-In / Move-Out",
  },
  {
    name: "James Wilson",
    role: "Father of 3 · Doral, FL",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20smiling%20friendly%20black%20man%20early%2040s%20casual%20bright%20background%20clean%20minimal%20portrait%20style%20photography&width=200&height=200&seq=avatar4&orientation=squarish",
    rating: 5,
    text: "With three kids and two dogs in our Doral home, things get messy fast. ZoroBabel&apos;s eco-friendly deep clean was exactly what we needed. The products are safe for the kids and pets, and the results were incredible. So glad I found them here in Miami!",
    service: "Deep Cleaning",
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const t = TESTIMONIALS[active];

  return (
    <section id="testimonials" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-xs font-semibold uppercase tracking-widest text-teal-600 mb-3 block">
            What Clients Say
          </span>
          <h2
            className="text-4xl md:text-5xl font-extrabold text-gray-900"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            5,000+ Happy Customers
          </h2>
        </div>

        {/* Main Testimonial */}
        <div className="bg-gray-950 rounded-3xl overflow-hidden grid grid-cols-1 md:grid-cols-5 min-h-72">
          {/* Image side */}
          <div className="md:col-span-2 relative h-72 md:h-auto overflow-hidden">
            <img
              key={active}
              src={t.avatar}
              alt={t.name}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-gray-950/30 hidden md:block" />
          </div>

          {/* Content side */}
          <div className="md:col-span-3 p-8 md:p-12 flex flex-col justify-center">
            <i className="ri-double-quotes-l text-5xl text-teal-500/40 mb-4" />
            <p className="text-white text-lg leading-relaxed font-light mb-6" style={{ fontFamily: "'Poppins', sans-serif" }}>
              {t.text}
            </p>
            <div>
              <p className="text-white font-bold text-base">{t.name}</p>
              <p className="text-white/50 text-xs mt-0.5">{t.role}</p>
              <span className="inline-block bg-teal-600/20 text-teal-400 text-xs px-3 py-1 rounded-full mt-2">
                {t.service}
              </span>
            </div>
            {/* Stars */}
            <div className="flex items-center gap-1 mt-4">
              {Array.from({ length: t.rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-sm" />
              ))}
            </div>
          </div>
        </div>

        {/* Selector Avatars */}
        <div className="flex items-center justify-center gap-4 mt-8">
          {TESTIMONIALS.map((test, i) => (
            <button
              key={test.name}
              onClick={() => setActive(i)}
              className={`w-12 h-12 rounded-full overflow-hidden border-2 transition-all cursor-pointer ${
                active === i ? "border-teal-500 scale-110" : "border-transparent opacity-50 hover:opacity-80"
              }`}
            >
              <img src={test.avatar} alt={test.name} className="w-full h-full object-cover object-top" />
            </button>
          ))}
        </div>

        {/* All Ratings Mini Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
          {TESTIMONIALS.map((test, i) => (
            <button
              key={test.name}
              onClick={() => setActive(i)}
              className={`text-left p-4 rounded-xl border transition-all cursor-pointer ${
                active === i
                  ? "border-teal-500 bg-teal-50"
                  : "border-stone-200 bg-white hover:border-teal-300"
              }`}
            >
              <div className="flex items-center gap-1 mb-2">
                {Array.from({ length: 5 }).map((_, si) => (
                  <i key={si} className="ri-star-fill text-amber-400 text-xs" />
                ))}
              </div>
              <p className="text-xs text-gray-500 line-clamp-2 mb-2">&ldquo;{test.text.substring(0, 80)}...&rdquo;</p>
              <p className="text-xs font-semibold text-gray-800">{test.name}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
